"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadController = void 0;
const wait_1 = require("../wait");
class UploadController {
    paused = false;
    promise;
    async waitIfPaused() {
        await (0, wait_1.waitForCondition)(() => !this.paused);
    }
    pause() {
        this.paused = true;
    }
    resume() {
        this.paused = false;
    }
    async completion() {
        if (!this.promise) {
            throw new Error('UploadController.completion() called before upload started');
        }
        return await this.promise;
    }
}
exports.UploadController = UploadController;
//# sourceMappingURL=controller.js.map